<template>
    <div
        class="wrapper"
        :style="{
            position: 'fixed',
            bottom: top + 'px',
            left: position.x + 'px',
            maxHeight: clientHeight
        }"
    >
        <div v-if="!indicatorList.length" class="empty">无搜索结果</div>
        <div
            v-for="(item, i) in indicatorList"
            :key="item.id"
            class="item"
            :class="{ active: i === index }"
            @click="clickAt($event, item)"
            @mouseenter="hoverAt(i)"
        >
            <div class="name">{{ item.name }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';

const props = defineProps(['visible', 'position', 'queryString', 'id', 'selectData']);
const emit = defineEmits(['onPick', 'onHide']);
const index = ref(-1);

const indicatorList = ref([]);
const clientHeight = document.documentElement.clientHeight;
const top = computed(() => {
    return clientHeight - props.position.y;
});

const initData = computed(() => {
    indicatorList.value = props.selectData
    return props.selectData
})
function keyDownHandler(e) {
    if (e.code === 'Escape') {
        emit('onHide');
        return;
    }
    // 键盘按下 => ↓
    if (e.code === 'ArrowDown') {
        if (index.value >= indicatorList.value.length - 1) {
            index.value = 0;
        } else {
            index.value = index.value + 1;
        }
    }
    // 键盘按下 => ↑
    if (e.code === 'ArrowUp') {
        if (index.value <= 0) {
            index.value = indicatorList.value.length - 1;
        } else {
            index.value = index.value - 1;
        }
    }
    // 键盘按下 => 回车
    if (e.code === 'Enter') {
        if (indicatorList.value.length) {
            let curr = indicatorList.value[index.value];
            const sel = {
                name: curr.name,
                id: curr.id,
                code: curr.code,
            };
            emit('onPick', sel);
            index.value = -1;
        }
        1;
    }
}
function clickAt(e, item) {
    const sel = {
        name: item.name,
        id: item.id,
        code: item.code,
    };
    emit('onPick', sel);
    index.value = -1;
}
function hoverAt(i) {
    index.value = i;
}
watch(
    () => props.queryString,
    val => {
        val
            ? (indicatorList.value = initData.value.filter(({ name }) =>
                  name.toLowerCase().match(new RegExp(val.toLowerCase()))
              ))
            : (indicatorList.value = initData.value);
    },
    {
        immediate: true
    }
);
onMounted(() => {
    document.addEventListener('keyup', keyDownHandler);
});
onUnmounted(() => {
    document.removeEventListener('keyup', keyDownHandler);
});
</script>

<style scoped lang="scss">
.wrapper {
    width: 238px;
    overflow: auto;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-sizing: border-box;
    padding: 6px 0;
    z-index: 9999;
}
.empty {
    font-size: 14px;
    padding: 0 20px;
    color: #999;
}
.item {
    font-size: 14px;
    padding: 0 20px;
    line-height: 34px;
    cursor: pointer;
    color: #606266;
    &.active {
        background: #f5f7fa;
        color: #3e7aff;
        .id {
            color: #3e7aff;
        }
    }
    &:first-child {
        border-radius: 5px 5px 0 0;
    }
    &:last-child {
        border-radius: 0 0 5px 5px;
    }
    .id {
        font-size: 12px;
        color: rgb(83, 81, 81);
    }
}
</style>
